import "./App.css";
import Paywall from "./pages/Paywall/Paywall";

function App() {
  return (
    <div className="App">
      <div className="bg-[#f2f3f5]">
        <Paywall />
      </div>
    </div>
  );
}

export default App;
